import { useEffect } from "react";
import { InputSlider } from "./InputSlider";
import "./MultipleInputSliders.scss";
import "./InputSliderTable.scss";
import {
  DataColumn,
  DataItem,
  ParentChildInterface,
} from "../../services/types/gallus";

interface InputSliderTableProps {
  /**
   * A collection of DataColumn objects, which represent a column in the table.
   */
  columns: DataColumn[];
  /**
   * Title of the table.
   */
  title: string;
  /**
   * field that refers to the index of the state to change using the onNewValuesChange function. Usable for multiple InputSliderTable instances in one parent component.
   */
  stateIndex: { indexOfState: number; indexOfSubArray: number };
  /**
   * A function that processes the changed value and it's location on the parent component.
   */
  onNewValuesChange: (value: ParentChildInterface) => void;
}

export const InputSliderTable = (props: InputSliderTableProps) => {
  /**
   * Updates the value of the changed input
   * @param changedValue New value of the input slider.
   * @param indexOfChangedValue Index of the value in the original data array.
   * @param indexOfSubArray Index of array inside the original state array to change.
   * @param indexOfState Index of the state the data array is located in.
   */
  const handleChange = (
    changedValue: number,
    changedValueIndex: number,
    subArrayIndex: number,
    stateIndex: number,
  ) => {
    props.onNewValuesChange({
      indexOfChangedValue: changedValueIndex,
      value: changedValue,
      indexOfSubArray: subArrayIndex,
      indexOfState: stateIndex,
    });
  };
  const generateRows = (data: DataItem[], columnIndex: number) => {
    var rowTMP: JSX.Element[] = [];
    data.map((row, rowIndex) => {
      rowTMP.push(
        <div style={{ display: "flex", justifyContent: "flex-end" }}>
          <div className="input-sliders-table-row-label">{row.label}</div>
          <div className="individual-is" key={rowIndex}>
            <InputSlider
              showLabel={false}
              startingValue={row.startingValue}
              leadingSymbol={row.firstSymbol}
              trailingSymbol={row.secondSymbol}
              label={row.label}
              onValueChange={(value) =>
                handleChange(
                  value,
                  rowIndex + columnIndex * data.length,
                  props.stateIndex.indexOfSubArray,
                  props.stateIndex.indexOfState ?? 0,
                )
              }
              labelVerticality={false}
              labelTop={false}
            />
          </div>
        </div>,
      );
    });
    return rowTMP;
  };

  const generateColumns = (
    columnObject: DataColumn,
    numberOfColumn: number,
  ) => {
    return (
      <div>
        <div className="input-sliders-table-column-title">
          {columnObject.columnTitle}
        </div>
        <div>{generateRows(columnObject.data, numberOfColumn)}</div>
      </div>
    );
  };

  const generateTable = () => {
    var columnsTMP: JSX.Element[] = [];
    props.columns.map((column, index) => {
      columnsTMP.push(generateColumns(column, index));
    });
    return <div style={{ display: "flex" }}>{columnsTMP}</div>;
  };

  return (
    <div>
      <div className="multiple-input-sliders-column-label">{props.title}</div>
      <div className="multiple-input-sliders-is-horizontal">
        {generateTable()}
      </div>
    </div>
  );
};
